// MoreInfo.js
import React from 'react';
import '../css/MoreInfo.css';

const MoreInfo = ({ visible, onHide, item }) => {
  if (!visible || !item) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2> Detalles del Medicamento</h2>
        <p><strong>Nombre:</strong> {item.NOMBRE}</p>
        <p><strong>Laboratorio:</strong> {item.LABORATORIO}</p>
        <p><strong>Componente Activo:</strong> {item.COMPONENTE}</p>
        <p><strong>Presentacion:</strong> {item.PRESENTACION}</p>
        <p><strong>Via:</strong> {item.VIA}</p>
        <p><strong>Acción:</strong> {item.ACCION}</p>
        <p><strong>Origen:</strong> {item.IMPORTADO}</p>
        <p><strong>Tipo de Venta:</strong> {item.TIPO_DE_VENTA}</p>
        <p><strong>Descuento PAMI:</strong> {item.D_PAMI}</p>
        <p><strong>Precio:</strong> ${item.PRECIO}</p>
        <p><strong>Precio PAMI:</strong> ${item.PRECIOPAMI}</p>
        <button onClick={onHide}>Cerrar</button>
      </div>
    </div>
  );
};

export default MoreInfo;
